import React from "react";
import { Link } from "react-router-dom";

function NewsLatterArea(props) {
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="latest-news sec-mar">
        <div className="container">
          <div className="row gx-4">
            <div className="col-md-6 col-lg-4 col-xl-4">
              <div className="signle-news">
                <div className="tag">
                  <Link onClick={scrollTop} to={"#"}>
                    Sites Web
                  </Link>
                </div>
                <div className="post-img">
                  <Link
                    onClick={scrollTop}
                    to={`${process.env.PUBLIC_URL}/blog-details`}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/images/post/post-1.jpg"}
                      alt="img"
                    />
                  </Link>
                </div>
                <div className="news-content">
                  <div className="author">
                    <div className="author-pic">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/images/author/author-1.jpg"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="author-info">
                      <h5>Par ABEOS Team</h5>
                      <span>20 Mars 2026</span>
                    </div>
                  </div>
                  <h3>
                    <Link
                      onClick={scrollTop}
                      to={`${process.env.PUBLIC_URL}/blog-details`}
                    >
                      Sites vitrines 2499 DH : booster votre visibilité
                      Casablanca
                    </Link>
                  </h3>
                  <p>
                    Découvrez comment nos sites responsive SEO-optimisés
                    génèrent 3x plus de leads pour PME marocaines. Étude de cas
                    réelle.
                  </p>

                  <div className="view-btn">
                    <Link
                      onClick={scrollTop}
                      to={`${process.env.PUBLIC_URL}/blog-details`}
                    >
                      Lire l'article
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4">
              <div className="signle-news">
                <div className="tag">
                  <Link onClick={scrollTop} to={"/"}>
                    Apps Web
                  </Link>
                </div>
                <div className="post-img">
                  <Link
                    onClick={scrollTop}
                    to={`${process.env.PUBLIC_URL}/blog-details`}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/images/post/post-2.jpg"}
                      alt="images"
                    />
                  </Link>
                </div>
                <div className="news-content">
                  <div className="author">
                    <div className="author-pic">
                      <img
                        src={
                          process.env.PUBLIC_URL + "/images/author/author-2.jpg"
                        }
                        alt="images"
                      />
                    </div>
                    <div className="author-info">
                      <h5>Par ABEOS Team</h5>
                      <span>18 Mars 2026</span>
                    </div>
                  </div>
                  <h3>
                    <Link
                      onClick={scrollTop}
                      to={`${process.env.PUBLIC_URL}/blog-details`}
                    >
                      Apps web scalables 4999 DH : croissance x10 en 6 mois
                    </Link>
                  </h3>
                  <p>
                    Comment nos applications web personnalisées automatisent vos
                    process et multiplient votre CA. Résultats chiffrés startups
                    Casablanca.
                  </p>

                  <div className="view-btn">
                    <Link
                      onClick={scrollTop}
                      to={`${process.env.PUBLIC_URL}/blog-details`}
                    >
                      Lire l'article
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4">
              <div className={`title ${props.black}`}>
                <span>Actualités</span>
                <h2>Tendances web design & digital Maroc 2026.</h2>
                <div className="cmn-btn">
                  <Link
                    onClick={scrollTop}
                    to={`${process.env.PUBLIC_URL}/blog`}
                  >
                    Tous les articles
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NewsLatterArea;
